import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";

import RecruitmentOverview from "./index";
import { FaMagnifyingGlass } from "react-icons/fa6";

const recruitmentHrRoutes = [	
    generateCRUDRoutes({
        mainTitle: "Recruitment Overview",
        basePath: "recruitment-overview",
        mainComponent: <RecruitmentOverview />,
        layout: "/console",
        icon: <FaMagnifyingGlass className="icon-item" />,
        subTitle:"Overviews",
        level:4,
        moduleId: 0,
    })
]

export default recruitmentHrRoutes;